// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manager-panel[data-v-c5a4b8e4]{margin:10px 0}.manager-panel>*[data-v-c5a4b8e4]{margin:5px 0}", ""]);
// Exports
module.exports = exports;
